module.exports = __webpack_public_path__ + "img/retry-img.043422d3.svg";